import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import pluralize from 'pluralize'
import {
  DetailList,
  Col,
  Row,
  ContentSectionBlock
} from 'camino-react'
import { cloudhelpGet } from 'Utilities/CloudHelp'

import { simpleHtmlFormat } from 'Utilities/StringManipulator'

class ListOfLinkedItemsModal extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      clientNotices: {}
    }
  }

  componentDidMount () {
    this.getClientNotices()
  }

  getClientNotices = () => {
    const { noticeItemsByType, clients } = this.props
    const clientNoticeItemsGroups = _.groupBy(noticeItemsByType.Client, 'noticeable_id')
    let clientNotices = {}
    
    _.some(clientNoticeItemsGroups) && (
      _.forEach(clientNoticeItemsGroups, clientNoticeItemsGroup => {
        const clientName = _.find(clients, { id: clientNoticeItemsGroup[0].noticeable_id }).short_name

        clientNotices[`${clientName}`] = []

        _.forEach(clientNoticeItemsGroup, clientNoticeItem => {
          cloudhelpGet(`/api/notices/${clientNoticeItem.notice_id}`)
            .then((response) => {
              const { data: { content } } = response

              clientNotices[clientName].push(content)

              this.setState({
                clientNotices: clientNotices,
              })
            })
          })
        })
      )
  }

  findClientName = (id, clientsList) => (clientsList ? _.find(clientsList, { id }).short_name : '')

  render () {
    const {
      clients,
      noticeItemsByType,
      ticketNotices,
      ticketProblemId,
      ticketProblemNotices,
      problemId,
      problemNotices
    } = this.props
    const { clientNotices } = this.state
    const { findClientName } = this

    const clientNoticeItemsGroups = _.groupBy(noticeItemsByType.Client, 'noticeable_id')
    const ticketNoticeItemsGroups = _.groupBy(noticeItemsByType.Ticket, 'noticeable_id')
    const displayedProblemNotices = ticketProblemNotices || problemNotices
    const displayedProblemId = problemId || ticketProblemId

    return (
      <Row>
        <Col>
          { _.some(displayedProblemNotices) && (
            <ContentSectionBlock title={'Problem'}>              
              <DetailList
                list={[
                  {
                    title: `#${displayedProblemId}`,
                    content: (
                    <>
                      <br />
                      <ul>
                        {_.map(displayedProblemNotices, notice => (
                          <li>
                            {simpleHtmlFormat(notice.content)}
                          </li>
                        ))}
                      </ul>
                    </>
                    )
                  }
                ]}
              />
            </ContentSectionBlock>
          )}

          { _.some(ticketNotices) && (
            <ContentSectionBlock title="Tickets">
              {_.map(ticketNoticeItemsGroups, ticketNoticeItemsGroup => {
                const prettyTicketId = `#${ticketNoticeItemsGroup[0].noticeable_id}`

                return (
                  <DetailList
                    list={[
                      {
                        title: prettyTicketId,
                        content: (
                        <>
                          <br />
                          <ul>
                            {_.map(ticketNotices, notice => (
                              <li>
                                {simpleHtmlFormat(notice.content)}
                              </li>
                            ))}
                          </ul>
                        </>
                        )
                      }
                    ]}
                  />
                )
              })}
            </ContentSectionBlock>
          )}

          { _.some(clientNotices) && (
            <ContentSectionBlock title={pluralize('Client', clients.length)}>
              {_.map(clientNoticeItemsGroups, (clientNoticeItemsGroup, index) => {
                const clientName = findClientName(clientNoticeItemsGroup[0].noticeable_id, clients)
                const clientId = clientNoticeItemsGroup[0].noticeable_id

                return (
                  <DetailList
                    key={index}
                    list={[
                      {
                        title: `#${clientId} - ${clientName}`,
                        content: (
                        <>
                          <br />
                          <ul>
                            {_.map(clientNotices[clientName], notice => (
                              <li>
                                {simpleHtmlFormat(notice)}
                              </li>
                            ))}
                          </ul>
                        </>
                        )
                      }
                    ]}
                  />
                )
              })}
            </ContentSectionBlock>
          )}
        </Col>
      </Row>
    )
  }
}

ListOfLinkedItemsModal.propTypes = {
  noticeItemsByType: PropTypes.objectOf(PropTypes.array).isRequired,
  clients: PropTypes.arrayOf(PropTypes.object).isRequired
}

export default ListOfLinkedItemsModal
